import { render } from "./SalesReportComponent.vue?vue&type=template&id=d5b10092"
import script from "./SalesReportComponent.vue?vue&type=script&lang=js"
export * from "./SalesReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/salesReport/SalesReportComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5b10092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5b10092', __exports__)) {
    api.reload('d5b10092', __exports__)
  }
  
  module.hot.accept("./SalesReportComponent.vue?vue&type=template&id=d5b10092", () => {
    api.rerender('d5b10092', render)
  })

}


export default __exports__